<template>
    <div class="inline-block">
        <transition name="fade">
            <div v-if="isVisible" class="fixed
                        w-full
                        h-full
                        max-h-full
                        inset-0
                        bg-black
                        bg-opacity-75
                        z-topmost
                        desktop:flex
                        desktop:justify-center
                        desktop:items-center" @click.self.prevent="dismiss()">
                <div class="flex
                            flex-col
                            justify-center" :class="maxSize ? `absolute inset-4 desktop:inset-12` :
                                fitContent ? `absolute desktop:relative
                                        inset-4 desktop:inset-0`:
                                    `desktop:max-w-prose
                                        absolute desktop:relative
                                        inset-4 desktop:inset-0`">
                                        
                    <div class="relative">
                        <XButton class="desktop:flex" @on-click="dismiss()" />
                    </div>

                    <div class="bg-white
                                text-navy
                                rounded-md
                                shadow
                                p-4
                                overflow-y-auto" 
                                :class="[borderRadius, setHeight ? 'desktop:h-212' : '']">
                        <div :class="`${borders} ${color}`">
                            <slot name="contents" />
                            <div v-if="$slots.confirm" class="text-center" @click.prevent="dismiss()">
                                 <slot name="confirm" />
                            </div>
                            <div class="text-center
                                        mt-4
                                        desktop:hidden">
                                <button v-if="!(isMobileEligible && isMobileInterested)" type="button"
                                    class="buyflow-button-alt" @click.prevent="dismiss()">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <span v-if="$slots.trigger" @click.prevent="disableModal ? null : show()">
            <slot name="trigger" />
        </span>
    </div>
</template>
<script>
import XButton from '@/atoms/XButton'
import { mapActions } from 'vuex' // TODO this shouldn't be here, but we have no choice

export default {
    name: 'AppModal',
    components: {
        XButton,
    },
    props: {
        overrideVisibility: {
            type: Boolean,
            default: false,
        },
        currentRouteName: {
            type: String,
            required: false,
            default: null,
        },
        disableModal: {
            type: Boolean,
            default: false,
        },
        isReallyVisible: {
            type: Boolean,
            default: false,
        },
        skipTrigger: {
            type: Boolean,
            default: false
        },
        modalType: {
            type: String,
            validator: val => [
                'info',
                'success',
                'warning',
                'danger',
            ].includes(val),
            default: 'info',
        },
        maxSize: {
            type: Boolean,
            default: false,
        },
        fitContent: {
            type: Boolean,
            default: false,
        },
        hasBorders: {
            type: Boolean,
            default: true,
        },
        setHeight: {
            default: false,
        },
        borderRadius: {
            type: String,
            default: 'rounded-md',
        },
    },
    data: () => ({
        isMobileEligible: true,
        isMobileInterested: true,
        isVisible: false,
    }),
    computed: {
        borders() {
            let borders = ''

            if (this.hasBorders) {
                borders = `border-2 p-4 ${this.borderRadius}`
            }
            return borders
        },
        color() {
            let color = ''

            switch (this.modalType) {
                case 'info':
                    color = 'text-navy border-navy'
                    break
                case 'success':
                    color = 'text-green-800 border-green-800'
                    break
                case 'warning':
                    color = 'text-yellow-800 border-yellow-800'
                    break
                case 'danger':
                    color = 'text-red-600 border-red-600'
                    break
            }

            return color
        },
    },
    watch: {
        isReallyVisible(val) {
            if (this.overrideVisibility) {
                this.isVisible = val
            }
        },
    },
    mounted() {
        if (this.overrideVisibility) {
            this.isVisible = this.isReallyVisible
        }
        if (this.skipTrigger) {
            this.isVisible = true
        }

    },
    methods: {
        ...mapActions([
            'adjustOpenOverlaysCounter'
        ]),
        show() {
            this.isVisible = true
            this.adjustOpenOverlaysCounter({ value: true })
        },
        dismiss() {
            console.log("dismiss event in AppModal")
            if (this.overrideVisibility) {
                this.$emit('dismiss')
            } else {
                this.isVisible = false
                this.$emit('dismiss')
                this.adjustOpenOverlaysCounter({ value: false })
            }
        },
    },
}
</script>
